import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './templateheader.css';

const Header = ({ setViewMode }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [mobileNavOpen, setMobileNavOpen] = useState(false);
    const location = useLocation();

    const handleNavToggle = () => setMobileNavOpen(open => !open);
    const handleNavLinkClick = () => setMobileNavOpen(false);

    // Show "Get Template" if on a template preview route, but NOT on the main type pages
    const isTemplatePreview =
        /^\/(agent|brokerage|landing)-/.test(location.pathname) &&
        !/^\/(agent-templates|brokerage-templates|landing-pages)(\/|$)/.test(location.pathname);

    return (
        <header className="main-header">
            <div className="header-left">
                <Link to="/" className="logo-link" onClick={handleNavLinkClick}>
                    <img
                        src={require('../../assets/imgs/aptowebsiteslogo.png')}
                        alt="Apto Websites Logo"
                        className="logo"
                    />
                </Link>
                {/* <span className="header-title-mobile">Apto Websites</span> */}
            </div>
            <button
                className={`mobile-nav-toggle${mobileNavOpen ? ' open' : ''}`}
                onClick={handleNavToggle}
                aria-label="Toggle navigation"
            >
                <span className="hamburger"></span>
                <span className="hamburger"></span>
                <span className="hamburger"></span>
            </button>
            <nav className={`nav-menu${mobileNavOpen ? ' open' : ''}`}>
                {/* <Link to="/" className="nav-link" onClick={handleNavLinkClick}>Information</Link> */}
                <div className="nav-item dropdown-wrapper">
                    <Link
                        to="/templates"
                        className="nav-link"
                        onClick={handleNavLinkClick}
                        tabIndex={0}
                    >
                        Templates
                    </Link>
                    <div className="dropdown-content">
                        <Link to="/agent-templates" onClick={handleNavLinkClick}>Agent</Link>
                        <Link to="/brokerage-templates" onClick={handleNavLinkClick}>Brokerage</Link>
                        <Link to="/landing-pages" onClick={handleNavLinkClick}>Landing Pages</Link>
                        <Link to="/newsletters" onClick={handleNavLinkClick}>Newsletters</Link>
                    </div>
                </div>
                <Link to="/socials" className="nav-link" onClick={handleNavLinkClick}>Social Media</Link>
                {/* <Link to="/signup" className="nav-link" onClick={handleNavLinkClick}>Get Started</Link> */}
                {!isTemplatePreview && (
                    <Link to="/pricing" className="nav-link" onClick={handleNavLinkClick}>Pricing</Link>
                )}
                {isTemplatePreview && (
                    <Link
                        to="/pricing"
                        className="get-template-btn"
                        onClick={handleNavLinkClick}
                    >
                        Get Template
                    </Link>
                )}
            </nav>
        </header>
    );
};

export default Header;
